module.exports = __webpack_public_path__ + "img/matriz.7ce0813d.jpg";